// @ts-nocheck
/* eslint-disable */
export const fromToLocationIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 63"><path stroke="#CECECE" d="M4.167 57.5v-52"/><rect width="30" height="4" x="6" y="16.5" fill="#172E63" rx="2" transform="rotate(90 6 16.5)"/><circle cx="4" cy="4.5" r="4" fill="#D9D9D9"/><path fill="#D9D9D9" d="M0 54.5h8v8H0z"/></svg>`,
    name: 'from-to-location' as const
};